module.exports = "<meta name=\"robots\" content=\"noindex, nofollow\">"